<template>
  <div class="TcTitle" v-if="title">
    <h1>{{title.label}}</h1>
    <span v-if="title.back" @click="$root.setPage(title.back)"
      class="text-xl absolute left-0 pl-5 cursor-pointer">&#8592; Volver</span>
    <span v-if="title.call_back" @click="title.call_back.action"
      class="text-xl absolute left-0 pl-5 cursor-pointer" v-html="title.call_back.label">...</span>
  </div>
</template>

<script>
export default {
  name: 'TcTitle',
  props: ['title','back_page'],
  data () {
    return {}
  },
}
</script>